<div class="replays-modal">
  <h2 md-dialog-title>
    Emission relation -
    <span *ngIf="spevId > 0">Sporting Event Id : {{ spevId }}</span>
    <span *ngIf="contentId != 'undefined' && contentId != '0'">Content Id : {{ contentId }}</span>
    <span *ngIf="!(spevId > 0) && programId > 0">Program Id : {{ programId }}</span>
    <span *ngIf="productCode != '0'">Product Code : {{ productCode }}</span>
  </h2>
  <md-dialog-content>
    <app-spinner *ngIf="loading"></app-spinner>
    <table *ngIf="!loading">
      <thead>
        <tr>
          <th>Channel</th>
          <th>Date</th>
          <th>Broadcasting</th>
          <th>Title</th>
          <th>&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let programArticle of programArticles"
          [ngClass]="{
            active:
              programArticle.id == id &&
              programArticle.valEmiId == valEmiId &&
              programArticle.channel.id == channelId
          }"
        >
          <td>
            {{ programArticle.channel.value }}
            <div
              *ngIf="
                programArticle.destinations[0] &&
                programArticle.destinations[0].value.pictureOnly
              "
              class="picture-only"
            >
              <md-icon>image</md-icon>
              Picture Only
            </div>
          </td>
          <td>
            {{ programArticle.startDate | date: "dd/MM/yyyy HH:mm" }} -
            {{ programArticle.endDate | date: "HH:mm" }}
          </td>
          <td>{{ programArticle.broadcasting.value }}</td>
          <td>
            <div
              *ngIf="
                programArticle.destinations[0] &&
                programArticle.destinations[0].value.translations[0]
              "
            >
              {{
                programArticle.destinations[0].value.translations[0].content
                  | undefinedString
              }}
            </div>
          </td>
          <td>
            <a
              md-icon-button
              target="_blank"
              [href]="
                '/program-articles/' +
                programArticle.valEmiId +
                '/' +
                programArticle.channel.id +
                '/' +
                programArticle.language.id +
                '/' +
                programArticle.cocoonId +
                '/' +
                isSeeReplay
              "
            >
              <md-icon>open_in_new</md-icon>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
    <br />
  </md-dialog-content>
</div>



// WEBPACK FOOTER //
// ./src/app/modals/replays-modal/replays-modal.component.html